import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=1a427af9&scoped=true&component=true&componentId=indexdd660a10"
import script from "./index.mpx?vue&type=script&lang=js&component=true&componentId=indexdd660a10"
export * from "./index.mpx?vue&type=script&lang=js&component=true&componentId=indexdd660a10"
import style0 from "./index.mpx?vue&type=style&index=0&id=1a427af9&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22mdd660a10%22%7D&component=true&componentId=indexdd660a10"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a427af9",
  null
  
)

export default component.exports